import type { SolanaConverter } from '../../type'
import convertUnknownToActions from './unknown'

const convertToActions: SolanaConverter = (args) => {
  // Use unknown converter which handles Jupiter swaps
  return convertUnknownToActions(args)
}

export default convertToActions
